import React, {
  createContext,
  useContext,
  useMemo,
  useEffect,
  useState,
} from 'react';
import FormProviderRenderer from './FormProviderRenderer';
import { useFormDebug } from './FormDebugProvider';

// Create a context for form permissions
const FormValidationContext = createContext({});

export function FormValidationProvider({
  validationSchema = null,
  fetchValidationSchema = null,
  children,
}) {
  const debug = useFormDebug();
  const [formValidationSchema, setFormValidationSchema] = useState(null);
  const [errors, setErrors] = useState([]);
  const [loading, setLoading] = useState(true);

  const initialize = async () => {
    setLoading(true);
    try {
      if (validationSchema !== null) {
        setFormValidationSchema(validationSchema);
      }
      if (
        fetchValidationSchema !== null ||
        typeof fetchValidationSchema === 'function'
      ) {
        const schemaFound = await fetchValidationSchema();
        if (schemaFound.data) {
          setFormValidationSchema(schemaFound?.data);
        } else if (schemaFound?.error) {
          setErrors(schemaFound?.error);
        }
      }
    } catch (err) {
      setErrors([{ message: err?.message }]);
    }

    setLoading(false);
  };

  useEffect(() => {
    debug.addStep('FormValidationSchema');
    initialize();
  }, [validationSchema, fetchValidationSchema]);

  const value = useMemo(
    () => ({ formValidationSchema }),
    [formValidationSchema],
  );

  return (
    <FormValidationContext.Provider value={value}>
      <FormProviderRenderer
        message="Loading Validation Schema"
        loading={loading}
        errors={errors}>
        {children}
      </FormProviderRenderer>
    </FormValidationContext.Provider>
  );
}

export const useFormValidationSchema = () => {
  return useContext(FormValidationContext);
};
